import type { CSSProperties, FC, ReactNode } from 'react';
import { Avatar } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import type { ResourceActivity } from '@/types';

import { resourceActivityIcon } from './icons';

interface ActivityIconAvatarProps {
    icon: ReactNode;
    size?: number;
    style?: CSSProperties;
}

interface ResourceActivityIconAvatarProps extends Omit<ActivityIconAvatarProps, 'icon'> {
    activity: Pick<ResourceActivity, 'eventType'>;
    iconSize?: number | string;
}

const ActivityIconAvatar: FC<ActivityIconAvatarProps> = ({ icon, size = 24, style }) => {
    const { token } = useAntDesignTheme();

    return (
        <Avatar
            aria-hidden='true'
            data-activity-icon-avatar='true'
            icon={icon}
            size={size}
            style={{
                alignItems: 'center',
                background: token.colorBgBase,
                border: `1px dashed ${token.colorBorder}`,
                color: token.colorTextTertiary,
                display: 'inline-flex',
                flex: 'none',
                justifyContent: 'center',
                ...style,
            }}
        />
    );
};

const ResourceActivityIconAvatar: FC<ResourceActivityIconAvatarProps> = ({
    activity,
    iconSize,
    size = 24,
    style,
}) => (
    <ActivityIconAvatar
        icon={resourceActivityIcon(activity, iconSize ?? (size <= 20 ? '0.75rem' : '1rem'))}
        size={size}
        style={style}
    />
);

export { ActivityIconAvatar };
export default ResourceActivityIconAvatar;
export type { ActivityIconAvatarProps, ResourceActivityIconAvatarProps };
